import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeocomplyResultStateService {
  public geofenceResultErrorMessage$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(
    undefined
  );

  public geofenceInProgress$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
